import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import AdminDashboard from "./pages/AdminDashboard";
import Login from "./Components/Auth/Login";
import Layout from "./Components/Layout";
import AttendancePage from "./pages/AttendancePage";
import MyProfile from "./pages/MyProfilePage";
import MyAttendecePage from "./pages/MyAttendecePage";
import { useEffect, useState } from "react";
import { Toast, ToastContainer } from "react-bootstrap"; // Import Toast components from Bootstrap
import Employeemanagement from "./pages/EmployeeManagement/Employeemanagement";
import AddEmployeeModal from "./Components/common/AddEmployeeModel";
import AdminLeaveManagement from "./pages/AdminLeaveManagement";
import AdminTimeSheet from "./pages/AdminTimeSheet/AdminTimeSheet";
import AdminDashboardnew from "./pages/AdminDashboard/AdminDashboardnew";
import Timesheet from "./pages/Timesheet";
import LeaveManagement from "./pages/LeaveManagement";
import DashBoardDetails from "./pages/DashBoardDetails";
import Profile from "./Components/common/Profile";
import ApplyLeave from "./pages/ApplyLeave";
import "./App.css";
import EmployeeManagement from "./pages/EmployeeManagement/Employeemanagement";
import ForgotPassword from "./Components/Auth/ForgotPassword/ForgotPassword";
import OTPVerification from "./Components/Auth/ForgotPassword/OTPVerification";
import CreateNewPassword from "./Components/Auth/ForgotPassword/CreateNewPassword";
import { Toaster } from "react-hot-toast";
import { jwtDecode } from "jwt-decode";
import DepartmentRole from "./pages/DepartmentRole/DepartmentRole";
import Leave from "./pages/Leave Management/Leave";
// import AddNewEmployee from "./pages/EmployeeManagement/AddNewEmployee";
import SendEmail from "./pages/EmployeeOnboarding/SendEmail";
import EmployeeOnboarding from "./pages/EmployeeOnboarding/EmployeeOnboarding";
import EmployeeForm from "./pages/EmployeeOnboarding/EmployeeForm";
import OnboardEmployees from "./pages/EmployeeOnboarding/OnboardEmployees";
import EmployeeProfile from "./pages/EmployeeOnboarding/EmployeeProfile";
import AnnexureSalary from "./pages/Cms/AnnexureSalary";
import Offboarding from "./pages/offboarding/Offboarding";
import UploadDocument from "./pages/CandidateScreen/UploadDocument";
import OffboardProfile from "./pages/offboarding/OffboardProfile";
import OffboardingConfig from "./pages/OffboardingConfig/OffboardingConfig";
import OffboardingDetails from "./pages/offboarding/OffboardingDetails";
import ProjectTrack from "./pages/Project track/ProjectTrack";

import MyProject from "./pages/Project track/MyProject";
import CreateNewProject from "./pages/Project track/CreateNewProject";
import EmployeeOffboarding from "./pages/offboarding/EmployeeOffboarding";

import TeamList from "./pages/Cms/Team/TeamList";
import TeamCreate from "./pages/Cms/Team/TeamCreate";
import TeamView from "./pages/Cms/Team/TeamView";
import ProjectDesc from "./pages/Project track/ProjectDesc";
import MyTask from "./pages/taskmangement/MyTask";
import TaskDetailedPage from "./pages/taskmangement/TaskDetailedPage";
import CreateTask from "./pages/taskmangement/CreateTask";
import AppointmentApprove from "./pages/AppointmentApprove/AppointmentApprove";
import GenerateMail from "./pages/GenaerateMail/GenerateMail";
import InvoiceList from "./pages/invoice/InvoiceList";
import InvoiceCreate from "./pages/invoice/InvoiceCreate";
import ViewInvoice from "./pages/invoice/ViewInvoice";
import Tenent from "./pages/Tenent/Tenent";
import CreateTenant from "./pages/Tenent/CreateTenant";
import DocumentSuccess from "./pages/CandidateScreen/DocumentSuccess";
import CompanyMasterCreate from "./pages/companyMaster/CompanyMasterCreate";
import CompanyMasterList from "./pages/companyMaster/CompanyMasterList";
import 'bootstrap/dist/css/bootstrap.min.css';
import CompanyMasterView from "./pages/companyMaster/CompanyMasterView";
import WorkOrderCreate from "./pages/workOrders/WorkOrderCreate";
import WorkOrderList from "./pages/workOrders/WorkOrderList";
import WorkOrderView from "./pages/workOrders/WorkOrderView";
import ResumeParser from "./pages/ResumeParser/ResumeParser";
import SalarySlipPdf from "./pages/salaryslip/SalarySlipPdf";
import SalarySlip from "./pages/salaryslip/SalarySlip";
import WorkOrderStatus from "./pages/workOrders/WorkOrderStatus";
import WOstatusUpdate from "./pages/workOrders/WOstatusUpdate";
import SalaryAnnexure from "./pages/Salary/SalaryAnnexure";


// import ApplyLeave from "./Components/Employee/ApplyLeave";

// Helper function to check authentication
const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  const expiryTime = localStorage.getItem("tokenExpiry");
  if (token && expiryTime) {
    return Date.now() < Number(expiryTime); // Return true if the token is not expired
  }
  return false;
};

// Helper function to get the user's role
// const getUserRole = () => {
//   const roles = localStorage.getItem("roles"); // Assume roles are stored in localStorage
//   return roles ? roles.split(",") : []; // Return roles as an array
// };
const token = localStorage.getItem("token");
// const getUserRole = (token) => {
//   try {
//     const decoded = jwtDecode(token);
//     // Example structure: { id: "123", email: "user@test.com", role: "admin" }
//     console.log("decoded", decoded)
//     return decoded.roles[0] || null;
//   } catch (error) {
//     console.error("Invalid token", error);
//     return null;
//   }
// };

export const useAuth = () => {
  const token = localStorage.getItem("token");

  return useMemo(() => {
    if (!token) {
      return { roles: [], isAuthenticated: false };
    }

    try {
      const decoded = jwtDecode(token);
      const expiryTime = decoded.exp * 1000;

      if (expiryTime < Date.now()) {
        return { roles: [], isAuthenticated: false };
      }

      return {
        roles: decoded.roles || [],
        isAuthenticated: true,
      };
    } catch {
      return { roles: [], isAuthenticated: false };
    }
  }, [token]);
};

const OffboardingWrapper = () => {
  const { roles } = useAuth();

  if (roles.includes("ROLE_EMP")) {
    return <EmployeeOffboarding />;
  }

  return <Offboarding />;
};

export const getUserRole = (token) => {
  try {
    const decoded = jwtDecode(token);
    console.log("Decoded JWT:", decoded);

    const roles = decoded.roles || []; // roles array from token
    const userName = decoded.userName || decoded.sub || null; // subject claim

    // Expiration (exp is in seconds, convert to ms)
    const expiryTime = decoded.exp ? decoded.exp * 1000 : null;

    return { roles, userName, expiryTime };
  } catch (error) {
    console.error("Invalid token", error);
    return { roles: [], userName: null, expiryTime: null };
  }
};
const role = getUserRole(token);

console.log("User role:", role);
// const token = localStorage.getItem("token");
const { roles = [] } = getUserRole(token); // default to empty array
// Public Route for Login - Only accessible if not authenticated
const PublicRoute = ({ children }) => {
  return isAuthenticated() ? <Navigate to="/" replace /> : children;
};

// Role-Based Redirect Component
const RoleBasedRedirect = () => {
  const token = localStorage.getItem("token"); // get token
  const { roles } = getUserRole(token);
  console.log("redirect", roles);
  if (roles.includes("ROLE_ADMIN") || roles.includes("ROLE_SYSTEM_ADMIN")) {
    return <Navigate to="/admin-dashboard" replace />;
  } else if (roles.includes("ROLE_EMP")) {
    return <Navigate to="/employee-dashboard" replace />;
  } else if (roles.includes("ROLE_MANAGER")) {
    return <Navigate to="/employee-dashboard" replace />;
  } else if (roles.includes("ROLE_FINANCE")) {
    return <Navigate to="/employee-dashboard" replace />;
  } else if (roles.includes("ROLE_HR")) {
    return <Navigate to="/employee-dashboard" replace />;
  } else if (roles.includes("ROLE_IT_MANAGER")) {
    return <Navigate to="/employee-dashboard" replace />;
  } else {
    return <Navigate to="/" replace />;
  }
};

// Private Route for Protected Pages
// const PrivateRoute = ({ children }) => {

//   return isAuthenticated() ? children : <Navigate to="/" replace />;
// };
// const PrivateRoute = ({ children, allowedRoles }) => {
//   const token = localStorage.getItem("token");
//   const { roles, expiryTime } = getUserRole(token);

//   // Check if token exists and not expired
//   if (!token || (expiryTime && expiryTime < Date.now())) {
//     return <Navigate to="/login" replace />;
//   }

//   // Check if user role is allowed
//   if (!allowedRoles.some(role => roles.includes(role))) {
//     return <Navigate to="/" replace />;  // unauthorized
//   }

//   return children;
// };
const PrivateRoute = ({ children, allowedRoles = [] }) => {
  const token = localStorage.getItem("token");
  const { roles = [], expiryTime } = getUserRole(token); // default to empty array

  // Check if token exists and not expired
  if (!token || (expiryTime && expiryTime < Date.now())) {
    return <Navigate to="/" replace />;
  }

  // If allowedRoles is empty, allow all authenticated users
  if (
    allowedRoles.length > 0 &&
    !allowedRoles.some((role) => roles.includes(role))
  ) {
    return <Navigate to="/" replace />; // unauthorized
  }

  return children;
};

function App() {
  const [isAuthenticatedState, setIsAuthenticatedState] =
    useState(isAuthenticated());
  const [showToast, setShowToast] = useState(false);

  // Automatically log out if the token is expired
  useEffect(() => {
    const expiryTime = localStorage.getItem("tokenExpiry");
    if (expiryTime && Date.now() > Number(expiryTime)) {
      localStorage.clear(); // Clear all authentication-related data
      setIsAuthenticatedState(false); // Update authentication state
      setShowToast(true); // Show error popup
      setTimeout(() => {
        window.location.href = "/"; // Redirect to login page after showing toast
      }, 3000);
    }
  }, []);

  // Monitor authentication state changes
  useEffect(() => {
    const interval = setInterval(() => {
      setIsAuthenticatedState(isAuthenticated());
    }, 100); // Check authentication status periodically
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="App">
      <ToastContainer position="top-right" autoClose={3000} />
      {/* Toast for Session Expiry */}
      <Toaster position="top-right" reverseOrder={false} />

      <Routes>
        {/* Public Route */}
        <Route path="/onboard" element={<UploadDocument />} />
        <Route
          path="/"
          element={
            isAuthenticatedState ? (
              <RoleBasedRedirect />
            ) : (
              <Login setIsAuthenticatedState={setIsAuthenticatedState} />
            )
          }
        // element={isAuthenticatedState ? <RoleBasedRedirect /> : <Login setIsAuthenticatedState={setIsAuthenticatedState} />}
        />
        <Route path="/document-success" element={<DocumentSuccess />} />
        <Route
          path="/"
          element={
            isAuthenticatedState ? (
              <RoleBasedRedirect />
            ) : (
              <Login setIsAuthenticatedState={setIsAuthenticatedState} />
            )
          }
        // element={isAuthenticatedState ? <RoleBasedRedirect /> : <Login setIsAuthenticatedState={setIsAuthenticatedState} />}
        />

        {/* Protected Routes */}
        {/* <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <AdminDashboard />
            </PrivateRoute>
          }
        /> */}
        <Route
          path="/layout"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN",
                "ROLE_MANAGER",
                "ROLE_EMP",
                "ROLE_SYSTEM_ADMIN",
              ]}
            >
              <Layout />
            </PrivateRoute>
          }
        />
        <Route
          path="/time-sheet"
          element={
            <PrivateRoute allowedRoles={["ROLE_EMP"]}>
              <AttendancePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-employee"
          element={
            <PrivateRoute
              allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER", "ROLE_SYSTEM_ADMIN"]}
            >
              <AddEmployeeModal />
            </PrivateRoute>
          }
        />
        <Route
          path="/deptrole"
          element={
            <PrivateRoute
              allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER", "ROLE_SYSTEM_ADMIN"]}
            >
              <DepartmentRole />
            </PrivateRoute>
          }
        />
        {/* <Route


        
          path="/admin-leave-managment"
          element={
            <PrivateRoute allowedRoles={["ROLE_MANAGER"]}>
              <AdminLeaveManagement />
            </PrivateRoute>
          }
        /> */}
        <Route
          path="/admin-timesheet"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_MANAGER",
                "ROLE_ADMIN",
                "ROLE_FINANCE",
                "ROLE_HR",
                "ROLE_IT_MANAGER",
                "ROLE_SYSTEM_ADMIN",
              ]}
            >
              <AdminTimeSheet />
            </PrivateRoute>
          }
        />
        <Route
          path="/emp-management"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN",
                "ROLE_MANAGER",
                "ROLE_FINANCE",
                "ROLE_HR",
                "ROLE_IT_MANAGER",
                "ROLE_SYSTEM_ADMIN",
              ]}
            >
              <EmployeeManagement />
            </PrivateRoute>
          }
        />
        <Route
          path="/mail-generate"
          element={
            <PrivateRoute allowedRoles={["ROLE_IT_MANAGER", "ROLE_ADMIN",]}>
              <GenerateMail />
            </PrivateRoute>
          }
        />
        <Route
          path="/emp-onbaord"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN",
                "ROLE_MANAGER",
                "ROLE_HR",
                "ROLE_SYSTEM_ADMIN",
              ]}
            >
              <OnboardEmployees />
            </PrivateRoute>
          }
        />
        <Route
          path="/emp-onboard/profile/:id"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN",
                "ROLE_MANAGER",
                "ROLE_HR",
                "ROLE_SYSTEM_ADMIN",
              ]}
            >
              <EmployeeProfile />
            </PrivateRoute>
          }
        />
        <Route
          path="/new-onboard"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN",
                "ROLE_MANAGER",
                "ROLE_HR",
                "ROLE_SYSTEM_ADMIN",
              ]}
            >
              <EmployeeOnboarding />
            </PrivateRoute>
          }
        />

        <Route
          path="/onboardAppoint-approve"
          element={
            <PrivateRoute allowedRoles={["ROLE_MANAGER", "ROLE_SYSTEM_ADMIN", "ROLE_ADMIN",]}>
              <AppointmentApprove />
            </PrivateRoute>
          }
        />
        <Route
          path="/teamList"
          element={
            <PrivateRoute
              allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER", "ROLE_SYSTEM_ADMIN"]}
            >
              <TeamList />
            </PrivateRoute>
          }
        />
        <Route
          path="/createteam"
          element={
            <PrivateRoute
              allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER", "ROLE_SYSTEM_ADMIN"]}
            >
              <TeamCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="/editTeam/:id"
          element={
            <PrivateRoute
              allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER", "ROLE_SYSTEM_ADMIN"]}
            >
              <TeamCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="/teamView/:id"
          element={
            <PrivateRoute
              allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER", "ROLE_SYSTEM_ADMIN"]}
            >
              <TeamView />
            </PrivateRoute>
          }
        />
        {/*  */}
        <Route
          path="/admin-dashboard"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN",
                "ROLE_MANAGER",
                "ROLE_HR",
                //"ROLE_IT_MANAGER",
                "ROLE_SYSTEM_ADMIN",
              ]}
            >
              <AdminDashboardnew />
            </PrivateRoute>
          }
        />
        <Route
          path="/salaryslip-pdf"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN",
                "ROLE_MANAGER",
                "ROLE_FINANCE",
                "ROLE_HR",
                "ROLE_IT_MANAGER",
                "ROLE_SYSTEM_ADMIN",
                "ROLE_EMP",
              ]}
            >
              <SalarySlipPdf />
            </PrivateRoute>
          }
        />
        <Route
          path="/salaryslip-table"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN",
                "ROLE_MANAGER",
                "ROLE_FINANCE",
                "ROLE_HR",
                "ROLE_EMP",
                "ROLE_IT_MANAGER",
                "ROLE_SYSTEM_ADMIN",
              ]}
            >
              <SalarySlip />
            </PrivateRoute>
          }
        />
        <Route
          path="/timesheet"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN",
                "ROLE_MANAGER",
                "ROLE_EMP",
                "ROLE_FINANCE",
                "ROLE_HR",
                "ROLE_IT_MANAGER",
                "ROLE_SYSTEM_ADMIN",
              ]}
            >
              <Timesheet />
            </PrivateRoute>
          }
        />
        <Route
          path="/employee-form"
          element={
            <PrivateRoute
              allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER", "ROLE_SYSTEM_ADMIN"]}
            >
              <EmployeeForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/annexure-salary"
          element={
            <PrivateRoute allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER"]}>
              <AnnexureSalary />
            </PrivateRoute>
          }
        />
        <Route
          path="/resume-parsur"
          element={
            <PrivateRoute allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER"]}>
              <ResumeParser />
            </PrivateRoute>
          }
        />
        <Route
          path="/off-boarding"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN",
                "ROLE_MANAGER",
                "ROLE_HR",
                "ROLE_FINANCE",
                "ROLE_IT_MANAGER",
                "ROLE_SYSTEM_ADMIN",
              ]}
            >
              <Offboarding />
            </PrivateRoute>
          }
        />
        <Route
          path="/off-boarding-employee"
          element={
            <PrivateRoute
              allowedRoles={[

                "ROLE_MANAGER",
                "ROLE_HR",
                "ROLE_FINANCE",
                "ROLE_IT_MANAGER",
                "ROLE_EMP",
                "ROLE_SYSTEM_ADMIN",
              ]}
            >
              <EmployeeOffboarding />
            </PrivateRoute>
          }
        />

        {/* <Route
          path="/off-boarding"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN",
                "ROLE_MANAGER",
                "ROLE_EMP",
                "ROLE_HR",
                "ROLE_FINANCE",
                "ROLE_IT_MANAGER"
              ]}
            >
              <OffboardingWrapper />
            </PrivateRoute>
          }
        /> */}

        <Route
          path="/off-boarding/profile-detail/:id"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN",
                "ROLE_MANAGER",
                "ROLE_IT_MANAGER",
                "ROLE_FINANCE",
              ]}
            >
              <OffboardProfile />
            </PrivateRoute>
          }
        />
        <Route
          path="/off-boarding-config"
          element={
            <PrivateRoute allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER"]}>
              <OffboardingConfig />
            </PrivateRoute>
          }
        />
        <Route
          path="/salary-annexure"
          element={
            <PrivateRoute allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER"]}>
              <SalaryAnnexure />
            </PrivateRoute>
          }
        />
        <Route
          path="/off-boardingDetails/:id"
          element={
            <PrivateRoute allowedRoles={["ROLE_HR", "ROLE_MANAGER"]}>
              <OffboardingDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/projecttrack"
          element={
            <PrivateRoute
              allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER", "ROLE_SYSTEM_ADMIN"]}
            >
              {/* <ProjectTrack/> */}
              <MyProject />
            </PrivateRoute>
          }
        />
        <Route
          path="/projectdashboard"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN",
                "ROLE_MANAGER",
                "ROLE_EMP",
                "ROLE_HR",
                "ROLE_FINANCE",
                "ROLE_IT",
                "ROLE_SYSTEM_ADMIN",
              ]}
            >
              <ProjectTrack />
            </PrivateRoute>
          }
        />
        <Route
          path="/mytask"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN",
                "ROLE_MANAGER",
                "ROLE_EMP",
                "ROLE_SYSTEM_ADMIN",
              ]}
            >
              <MyTask />
            </PrivateRoute>
          }
        />
        <Route
          path="/createtask"
          element={
            <PrivateRoute
              allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER", "ROLE_SYSTEM_ADMIN"]}
            >
              <CreateTask />
            </PrivateRoute>
          }
        />
        <Route
          path="/tenent"
          element={
            <PrivateRoute allowedRoles={["ROLE_SYSTEM_ADMIN"]}>
              <Tenent />
            </PrivateRoute>
          }
        />
        <Route
          path="/createTenant"
          element={
            <PrivateRoute allowedRoles={["ROLE_SYSTEM_ADMIN"]}>
              <CreateTenant />
            </PrivateRoute>
          }
        />
        {/* <Route
          // path="/mytaskdetailed"
          path="/mytaskdetailed"
          element={
            <PrivateRoute allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER","ROLE_EMP",]} >
              <MyTask />

            </PrivateRoute>
          }
        /> */}
        <Route
          // path="/mytaskdetailed"
          path="/mytaskdetailed/:taskId"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN",
                "ROLE_MANAGER",
                "ROLE_EMP",
                "ROLE_SYSTEM_ADMIN",
              ]}
            >
              <TaskDetailedPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/create-new-project"
          element={
            <PrivateRoute
              allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER", "ROLE_SYSTEM_ADMIN"]}
            >
              <CreateNewProject />
            </PrivateRoute>
          }
        />
        <Route
          path="/projectDesc/:id"
          element={
            <PrivateRoute allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER"]}>
              <ProjectDesc />
            </PrivateRoute>
          }
        />

        <Route
          path="/send-email"
          element={
            <PrivateRoute allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER"]}>
              <SendEmail />
            </PrivateRoute>
          }
        />
        <Route
          path="/leave-management"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN",
                "ROLE_MANAGER",
                "ROLE_EMP",
                "ROLE_HR",
                "ROLE_FINANCE",
                "ROLE_IT_MANAGER",
                "ROLE_SYSTEM_ADMIN",
              ]}
            >
              <Leave />
            </PrivateRoute>
          }
        />
        <Route
          path="/list-invoice"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_FINANCE",
                "ROLE_IT_MANAGER", "ROLE_SYSTEM_ADMIN", "ROLE_ADMIN"]}
            >
              <InvoiceList />
            </PrivateRoute>
          }
        />
        <Route
          path="/create-invoice"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_FINANCE",
                "ROLE_IT_MANAGER", "ROLE_SYSTEM_ADMIN", "ROLE_ADMIN"]}
            >
              <InvoiceCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="/create-company-master"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN", "ROLE_FINANCE"]}
            >
              <CompanyMasterCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="/work-order"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN", "ROLE_FINANCE"]}
            >
              <WorkOrderCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="/work-order-received"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN", "ROLE_FINANCE"]}
            >
              <WOstatusUpdate />
            </PrivateRoute>
          }
        />
        <Route
          path="/work-orderStatus"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN", "ROLE_FINANCE"]}
            >
              <WorkOrderStatus />
            </PrivateRoute>
          }
        />

        <Route
          path="/work-order-view/:id"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN", "ROLE_FINANCE"]}
            >
              <WorkOrderView />
            </PrivateRoute>
          }
        />
        <Route
          path="/work-orderlist"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN", "ROLE_FINANCE"]}
            >
              <WorkOrderList />
            </PrivateRoute>
          }
        />

        <Route
          path="/company-maslist"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN", "ROLE_FINANCE"]}
            >
              <CompanyMasterList />
            </PrivateRoute>
          }
        />
        <Route
          path="/company-masterview/:id"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN", "ROLE_FINANCE"
              ]}
            >
              <CompanyMasterView />
            </PrivateRoute>
          }
        />
        <Route
          path="/view-invoice/:id"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_FINANCE",
                "ROLE_IT_MANAGER", "ROLE_SYSTEM_ADMIN", "ROLE_ADMIN"]}
            >
              <ViewInvoice />
            </PrivateRoute>
          }
        />

        <Route
          path="/my-attendence"
          element={
            <PrivateRoute
              allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER", "ROLE_EMP"]}
            >
              <MyAttendecePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/employee/settings"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN",
                "ROLE_MANAGER",
                "ROLE_EMP",
                "ROLE_SYSTEM_ADMIN",
              ]}
            >
              <ApplyLeave />
            </PrivateRoute>
          }
        />
        <Route
          path="/employee-dashboard"
          element={
            <PrivateRoute allowedRoles={["ROLE_EMP",
              "ROLE_MANAGER", "ROLE_ADMIN",
              "ROLE_HR", "ROLE_IT_MANAGER", "ROLE_FINANCE"
            ]}>
              <DashBoardDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/settings"
          element={
            <PrivateRoute
              allowedRoles={["ROLE_ADMIN", "ROLE_MANAGER", "ROLE_SYSTEM_ADMIN"]}
            >
              <MyProfile />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute
              allowedRoles={[
                "ROLE_ADMIN",
                "ROLE_MANAGER",
                "ROLE_EMP",
                "ROLE_SYSTEM_ADMIN",
                "ROLE_IT_MANAGER",
              ]}
            >
              <Profile />
            </PrivateRoute>
          }
        />
        <Route
          path="/apply-leave"
          element={
            <PrivateRoute>
              <ApplyLeave />
            </PrivateRoute>
          }
        />
        <Route
          path="/forgotPassword"
          element={
            // <PrivateRoute>
            <ForgotPassword />
            // </PrivateRoute>
          }
        />
        <Route
          path="/forgot-password/otpverification"
          element={
            // <PrivateRoute>
            <OTPVerification />
            // </PrivateRoute>
          }
        />
        <Route
          path="/forgot-password/createnewpassword"
          element={
            // <PrivateRoute>
            <CreateNewPassword />
            // </PrivateRoute>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
